class TruncateText extends HTMLElement {
    constructor() {
        super();
        this.truncatedText = document.getElementById('truncated-text');
        this.fullText = document.getElementById('full-text');
        this.button = document.getElementById('toggle-button');
        this.buttonLess = document.getElementById('toggle-button-less');
        this.init();  
    }
    init () {
        this.button.addEventListener('click', () => {
            if (this.fullText.style.display === 'none') {
                this.fullText.style.display = 'block';
                this.truncatedText.style.display = 'none';
              } else {
                this.fullText.style.display = 'none';
                this.truncatedText.style.display = 'block';
              }
        })
        this.buttonLess.addEventListener('click', () => {
            if (this.fullText.style.display === 'none') {
                this.fullText.style.display = 'block';
                this.truncatedText.style.display = 'none';
              } else {
                this.fullText.style.display = 'none';
                this.truncatedText.style.display = 'block';
              }
        })
    }
}

customElements.define('truncate-text', TruncateText);